import React from "react";
import { RecoilRoot } from "recoil";
import CustomRoutes from "./router";
import { ConfigProvider } from "antd";
import { BrowserRouter as Router } from "react-router-dom";
import AxiosContextProvider from "./contexts/AxiosContext";
import { QueryClient, QueryClientProvider } from "react-query";

const queryClient = new QueryClient();

function App() {
  return (
    <RecoilRoot>
      <Router>
        <AxiosContextProvider>
          <QueryClientProvider client={queryClient}>
            <ConfigProvider
              theme={{
                components: {
                  Button: { colorPrimary: "#990000" },
                  Checkbox: { colorPrimary: "#990000" },
                  Tabs: { colorPrimary: "#990000", colorBgContainer: "#fbf5f5", itemHoverColor: "#990000" },
                },
              }}
            >
              <CustomRoutes />
            </ConfigProvider>
          </QueryClientProvider>
        </AxiosContextProvider>
      </Router>
    </RecoilRoot>
  );
}

export default App;
